import { AppVariant } from "src/config/appVariants";

interface UserVariant {
    appVariant?: string;
    isClient?: boolean;
}

export function isCheckedInClient(user: UserVariant | null | undefined): boolean {
    return user?.appVariant === AppVariant.CHECKED_IN && user.isClient === true;
}

export function canUseVideoCalling(user: UserVariant | null | undefined): boolean {
    return user?.appVariant !== AppVariant.CHECKED_IN;
}
